import { LoadCarrierTypeV1 } from '@/modules/setupV2/components/LoadCarrierTypes/types';

export const numberOfColumns = (
  length: number,
  gap: number,
  margin: number,
  objectWidth: number,
): number => {
  if (length <= objectWidth) return 0;
  if (length <= objectWidth * 2 + gap + margin * 2) return 1;
  return Math.floor((length - 2 * margin + gap) / (objectWidth + gap));
};

export const numberOfRows = (length: number, loadLength: number, gap: number): number =>
  Math.floor((length + gap) / (loadLength + gap));

/**
 * @description takes in a collection of load carriers,
 * converts their dimensions to conform to the mathematical rectangle representation (length always > width),
 * determines the bounding box based on these representations and returns it in the math rectangle representation
 *
 * @example
 * ([{..., length: 900, width: 1100}, {..., length: 1200, width: 800}])
 * =>
 * {length: 1200, width: 900}
 */
export const calcOrientedLoadCarriersBoundingBox = (loadCarriers: LoadCarrierTypeV1[]) => {
  const fallbackWidth = 0;
  const fallbackLength = 0;
  const fallbackHeight = 0;
  const lengths: number[] = [];
  const widths: number[] = [];
  const heights: number[] = [];

  loadCarriers.forEach((item) => {
    if (item.length > item.width) {
      lengths.push(item.length);
      widths.push(item.width);
      heights.push(item.height);
    } else {
      lengths.push(item.width);
      widths.push(item.length);
      heights.push(item.height);
    }
  });

  return {
    width: Math.max(...widths, fallbackWidth),
    length: Math.max(...lengths, fallbackLength),
    height: Math.max(...heights, fallbackHeight),
  };
};
